module.exports = __webpack_public_path__ + "media/images/computer-31f8aa29339dbc27dc54302db1b9ef77.jpeg";